import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=7608266a&scoped=true&"
import script from "./CallHistory.vue?vue&type=script&lang=ts&"
export * from "./CallHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=7608266a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608266a",
  null
  
)

export default component.exports